export class OrganizationSetupCommon {
public static clientFormErrors = {
  "alias": "",
  "branch": "",
  "chargeableToClient": "",
  "cinNumber": "",
  "ediaryStatus": "",
  "email": "",
  "gstNumber": "",
  "legalStatus": "",
  "llpinNumber": "",
  "name": "",
  "pan": "",
  "principalPlaceOfBusiness": "",
  "sector": "",
  "id":"",
  "fromDate":"",
  "toDate":"",
  "address": "",
  "state":"",
  "city": "",
  "postCode": "",
  "distance":"",
  "amount":"",
  "isSign":"",
  "remark":"",
  
};

public static clientFormValidationMessages = {
  "alias": { 'required': 'mandatory field'},
  "branch": { 'required': 'mandatory field'},
  "chargeableToClient":{ 'required': 'mandatory field'},
  "cinNumber":{'required':'mandatory field', 'pattern' : "21 characters expected"},
  "ediaryStatus": { 'required': 'mandatory field'},
  "email": { 'required': 'mandatory field', 'email' : "invalid email format"},
  "gstNumber": { 'required': 'mandatory field'},
  "legalStatus": { 'required': 'mandatory field'},
  "llpinNumber": { 'required': 'mandatory field', 'pattern' : "Alpha numeric characters expected Eg:AAN-2345"},
  "name": { 'required': 'mandatory field'},
  "pan": { 'required': 'mandatory field', 'pattern': 'invalid pan'},
  "principalPlaceOfBusiness": { 'required': 'mandatory field'},
  "sector": { 'required': 'mandatory field'},
  "id":{ 'required': 'mandatory field'},
  "fromDate":{ 'required': 'mandatory field'},
  "toDate":{ 'required': 'mandatory field'},
  "address": { 'required': 'mandatory field'},
  "state":{ 'required': 'mandatory field'},
  "city": { 'required': 'mandatory field'},
  "postCode": { 'required': 'mandatory field'},
  "distance":{ 'required': 'mandatory field'},
  "amount":{ 'required': 'mandatory field'},
  "isSign":{ 'required': 'mandatory field'},
  "remark":{ 'required': 'mandatory field'},
};


public static conveyanceFormErrors = {
"allowFourWheeler": "",
"allowTwoWheeler": "",
"effectiveDate": "",
"fourWheelerNonChargableRate": "",
"fourWheelerRate": "",
"role": "",
"twoWheelerRate": "",
};

public static conveyanceFormValidationMessages = {
/* "allowFourWheeler": { 'required': 'mandatory field'},
"allowTwoWheeler": { 'required': 'mandatory field'}, */
"effectiveDate": { 'required': 'mandatory field'},
/* "fourWheelerNonChargableRate":{ 'required': 'mandatory field'},
"fourWheelerRate": { 'required': 'mandatory field'},
"twoWheelerRate": { 'required': 'mandatory field'}, */
"role": { 'required': 'mandatory field'},
};

public static standardRateFormErrors = {
"role": "",
"serviceVertical": "",
"financialYear": "",
"branch": "",
"rate": "",
};

public static standardRateFormValidationMessages = {
"role": { 'required': 'mandatory field'},
"serviceVertical": { 'required': 'mandatory field'},
"financialYear": { 'required': 'mandatory field'},
"branch": { 'required': 'mandatory field'},
"rate": { 'required': 'mandatory field'},
};

public static holidayFormErrors = {
"branch": "",
"holidayDate": "",
"holidayDescription": "",
};

public static holidayFormValidationMessages = {
"branch": { 'required': 'mandatory field'},
"holidayDate": { 'required': 'mandatory field'},
"holidayDescription": { 'required': 'mandatory field'},
};


public static artcleStipendFormErrors = {
"financialYear": "",
"branch": "",
"articleYear": "",
"effectiveDate": "",
"stipendPerMonth": "",
};

public static artcleStipendFormValidationMessages = {
"financialYear": { 'required': 'mandatory field'},
"branch": { 'required': 'mandatory field'},
"articleYear": { 'required': 'mandatory field'},
"effectiveDate": { 'required': 'mandatory field'},
"stipendPerMonth": { 'required': 'mandatory field'},
};

public static artcleVacancyFormErrors = {
  "partnerName": "",
  "articleEligibility": "",
  };

  public static artcleVacancyFormValidationMessages = {
    "partnerName": { 'required': 'mandatory field'},
    "articleEligibility": { 'required': 'mandatory field'},
    };

public static companyConfigFormErrors = {
  "artCreditHours": "",
  "artMonthlyLeaveDays": "",
  "artMonthlyWorkingDays": "",
  "artWeeklyWorkingDays": "",
  "artWorkingHours": "",
  "empCreditHours": "",
  "empMonthlyLeaveDays": "",
  "empMonthlyWorkingDays": "",
  "empWeeklyWorkingDays": "",
  "empWorkingHours": "",
};

public static companyConfigFormValidationMessages = {
  "artCreditHours": { 'required': 'mandatory field'},
  "artMonthlyLeaveDays": { 'required': 'mandatory field'},
  "artMonthlyWorkingDays": { 'required': 'mandatory field'},
  "artWeeklyWorkingDays": { 'required': 'mandatory field'},
  "artWorkingHours": { 'required': 'mandatory field'},
  "empCreditHours": { 'required': 'mandatory field'},
  "empMonthlyLeaveDays": { 'required': 'mandatory field'},
  "empMonthlyWorkingDays": { 'required': 'mandatory field'},
  "empWeeklyWorkingDays": { 'required': 'mandatory field'},
  "empWorkingHours": { 'required': 'mandatory field'},
}


public static budgetFormErrors = {
  "assignedPartner": "",
  "assignment": "",
  "assignmentFees": "",
  "branch": "",
  "client": "",
  "financialYear": "",

  "role": "",
  "employee": "",

  "standardRate": "",
  "budgetedDays": "",
  "count": "",
  "fromDate": "",
  "toDate": "",

};

public static budgetFormValidationMessages = {
  "assignedPartner": { 'required': 'mandatory field'},
  "assignment": { 'required': 'mandatory field'},
  "assignmentFees": { 'required': 'mandatory field'},
  "branch": { 'required': 'mandatory field'},
  "client": { 'required': 'mandatory field'},
  "financialYear": { 'required': 'mandatory field'},

  "role": { 'required': 'mandatory field'},
  "employee": { 'required': 'mandatory field'},

  "standardRate": { 'required': 'mandatory field'},
  "budgetedDays": { 'required': 'mandatory field'},
  "count": { 'required': 'mandatory field'},
  "fromDate": { 'required': 'mandatory field' , 'incorrect':' invalid date please check overlapping dates'},
  "toDate": { 'required': 'mandatory field', 'incorrect':' invalid date please check overlapping dates'},
}

}


